module.exports = __webpack_public_path__ + "logo-klarna.89400af4e54060856f5da3f861682966.svg";